import { render, staticRenderFns } from "./select-year-month.vue?vue&type=template&id=3b0d2248&"
import script from "./select-year-month.vue?vue&type=script&lang=js&"
export * from "./select-year-month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports